export enum PriceStatus {
  Up = 'up',
  Down = 'down',
  None = '',
}
